import { lazy } from "react";
import { BASE_PATH } from "context/SiteSettingsContext/utils";
import { ERouteMappingKeys } from "./routeKeys";

export const trustCenterRoutes = {
  [ERouteMappingKeys.TRUST_CENTER]: {
    id: "trust-center",
    path: "/trust-center",
    components: {
      [BASE_PATH]: lazy(() =>
        import("pages/Sections/TrustCenter").then((p) => ({
          default: p.TrustCenter,
        })),
      ),
    },
  },
};
